import { render } from "./VtoSnackbar.vue?vue&type=template&id=7fc6e8ba"
import script from "./VtoSnackbar.vue?vue&type=script&lang=js"
export * from "./VtoSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__